import Button from '@/common/components/base/button/Button';
import Typography from '@/common/components/base/typography/Typography';
import MainLayout from '@/common/components/layouts/MainLayout';
import { DASHBOARD_LINKS } from '@/modules/Dashboard/DashboardLinks';
import ArrowUpImage from '@/modules/Statistics/assets/icons/arrow-up.svg?react';
import { useQuery } from '@tanstack/react-query';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import EmptyStatisticModal from '../components/modals/EmptyStatisticModal';
import StatisticComplaintSection from '../components/statistic-complaint-section/StatisticComplaintSection';
import StatisticInfo from '../components/statistic-info/StatisticInfo';
import StatisticPerformanceSection from '../components/statistic-performance-section/StatisticPerformanceSection';
import StatisticRateSection from '../components/statistic-rate-section/StatisticRateSection';
import StatisticSurveySection from '../components/statistic-survey-section/StatisticSurveySection';
import { getEvaluationSummaryQueryOptions } from '../queries/getEvaluationSummary/getEvaluationSummaryQueryOptions';

const StatisticsPage = () => {
  const navigate = useNavigate();
  const [shouldShowEmptyModal, setShouldShowEmptyModal] = useState(true);

  const { data, isSuccess } = useQuery(
    getEvaluationSummaryQueryOptions({ user_type: 'adjuster' }),
  );

  const hasNoFiles = !!data && Number(data.national_rank) <= 0;

  const goToProfile = () => {
    setShouldShowEmptyModal(false);
    navigate(DASHBOARD_LINKS.profile);
  };

  return (
    <MainLayout header="titleHeader" title="آمار و عملکرد" navbar>
      <Statistics />
      {isSuccess && (
        <EmptyStatisticModal
          open={hasNoFiles && shouldShowEmptyModal}
          closeModal={goToProfile}
          onConfirm={goToProfile}
          closeOnBackdrop={false}
        />
      )}
    </MainLayout>
  );
};

function Statistics() {
  const countryRankRef = useRef<HTMLDivElement | null>(null);
  const performanceRef = useRef<HTMLDivElement | null>(null);
  const surveyRef = useRef<HTMLDivElement | null>(null);
  const complaintRef = useRef<HTMLDivElement | null>(null);

  const scrollTo = (ref: React.RefObject<HTMLDivElement | null>) => {
    ref.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Box padding="2px 0px" display="flex" flexDirection="column">
      <StatisticInfo
        onSelect={(id) => {
          if (id === 1) scrollTo(countryRankRef);
          if (id === 2) scrollTo(performanceRef);
          if (id === 3) scrollTo(surveyRef);
          if (id === 4) scrollTo(complaintRef);
        }}
      />
      <StatisticRateSection countryRankRef={countryRankRef} />
      <Box backgroundColor="gray-3" height={4} width="100%" margin="32px 0px" />

      <Box ref={performanceRef}>
        <StatisticPerformanceSection />
      </Box>

      <Box backgroundColor="gray-3" height={4} width="100%" margin="32px 0px" />
      <Box ref={surveyRef}>
        <StatisticSurveySection />
      </Box>

      <Box backgroundColor="gray-3" height={4} width="100%" margin="32px 0px" />

      <Box ref={complaintRef}>
        <StatisticComplaintSection />
      </Box>
      <Flex
        alignItems="center"
        justifyContent="center"
        margin="32px 0px"
        pb="30px"
      >
        <Button
          className={css({
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            width: '50%',
            bgColor: 'purple-6',
            borderRadius: '8px',
            padding: '7px 16px',
          })}
          onClick={scrollToTop}
        >
          <Typography
            color="purple-primary"
            cursor="pointer"
            whiteSpace="nowrap"
          >
            بازگشت به بالا
          </Typography>
          <ArrowUpImage width={20} height={20} />
        </Button>
      </Flex>
    </Box>
  );
}
export default StatisticsPage;
